import { ref, unref } from 'vue';
import store from '@/store';
import { config } from '@/config.js';

/**
 * usePedidoDetalle — fetches a single pedido detail from the v2 endpoint.
 * Caches the result so repeat expands don't issue a second request.
 *
 * @param {Ref<number|string>|number|string} pedidoIdSource — pedido id (ref or plain value)
 */
export function usePedidoDetalle(pedidoIdSource) {
    const detalle = ref(null);
    const loading = ref(false);
    const error   = ref(null);

    const getPedidoId = () => unref(pedidoIdSource);

    const fetchDetalle = async() => {
        if (detalle.value || loading.value || !getPedidoId()) return;

        loading.value = true;
        error.value   = null;

        try {
            const res = await store.dispatch(
                config.getVuexAlias('front.perfil.v2.pedidos.detalle'),
                { pedido_id: getPedidoId() },
            );
            detalle.value = res.data.data ?? res.data;
            if (detalle.value?.entradas) {
                detalle.value.entradas = detalle.value.entradas.map(e => ({
                    ...e,
                    qr_code: e.codigo_qr,
                }));
            }
            if (detalle.value?.products) {
                detalle.value.products = detalle.value.products.map(p => ({
                    ...p,
                    image: p.imagen,
                }));
            }
        } catch (err) {
            error.value = err?.message || 'Error al cargar el detalle del pedido';
        } finally {
            loading.value = false;
        }
    };

    return { detalle, loading, error, fetchDetalle };
}
